import { Injectable } from '@angular/core';

import { RestService } from "../../../../core/services/rest.service";
import { apiName } from "./data.service";
import { TipoContato } from "./contato-tipo.model";

@Injectable()
export class ContatoTipoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: TipoContato, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoContato, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"where":{"ativo":true},"order":"tipo"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/contatos/contato-tipos/shared/contato-tipo-api.service.ts
 **/